import { useState, useEffect } from 'react';

const DESKTOP_QUERY = '(min-width: 768px)';

/**
 * Returns true when the viewport is >= 768px (tablet breakpoint).
 * Used for structural JSX changes (sidebar mode, header swaps).
 * For styling-only changes, use the `tablet` helper from `src/media.ts` instead.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(DESKTOP_QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}
